import { useEffect, useContext } from 'react';
import { useActionFigureListing, useContentful, useItemsListing } from '../hooks';
import { BroadsiderHud, LoadingSpinner } from '../components';
import { AppContext } from '../providers/AppContext';
import { useWalletClient } from 'wagmi';
import useIsMobile from '../hooks/useIsMobile';
import { useNavigate } from "react-router-dom";

const NoBroadsider = () => {
  return (<div>You have 0 Broadsiders!</div>);
};

export default function Account({ accountAddress }) {
  const { selectedBroadsider, setSelectedBroadsider, ownedBroadsiders, walletAddress, equipmentSignature, setOwnedBroadsiders, setMetaverseItems, setPromoItems, promoItems, setInventoryItems, inventory } = useContext(AppContext);
  const { isLoading, items } = useActionFigureListing(walletAddress, equipmentSignature);
  const { isLoading: dataIsLoading, metaverseItems, promo } = useContentful();
  const { data: walletClient } = useWalletClient();
  //const { isLoading: inventoryIsLoading, items: assets } = useItemsListing(selectedBroadsider ? selectedBroadsider.get6551Address(walletClient) : null, selectedBroadsider);
  const { isLoading: inventoryIsLoading, items: assets } = useItemsListing(walletAddress, selectedBroadsider);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const noFiguresToShow = !isLoading && items.length < 1 && !selectedBroadsider;

  useEffect(() => {
    if (items.length > 0 && !selectedBroadsider) {
      setSelectedBroadsider(items[0]);
    }
    setOwnedBroadsiders(items);
  }, [items.length]);

  useEffect(() => {
    if (isMobile) {
      navigate('/home');
    }
  }, [isMobile]);

  useEffect(() => {
    setMetaverseItems(metaverseItems);
    setPromoItems(promo);
    setInventoryItems(assets);
  }, [metaverseItems.length, promo.length, assets.length, selectedBroadsider]);

  const loading = isLoading || dataIsLoading || inventoryIsLoading;
  return (
    <div className='page'>
      {loading && <LoadingSpinner />}
      {noFiguresToShow && <NoBroadsider />}
      {(!loading && selectedBroadsider) && <BroadsiderHud
        figure={selectedBroadsider}
        promoOptions={promoItems}
        inventory={inventory}
        metaverseData={metaverseItems}/>}
    </div>
  );
}
